export class SOAPPaymentRequest {
    email!: string;
    speedFrameToken!: string;
    creditAccount!: string;
    amount!: number;
    debitName!: string;
    debitZip!: string;
    recurring: boolean = false;
    paymentMethod : PaymentMethod = new PaymentMethod();
    invoiceData: Array<InvoiceData> = new Array<InvoiceData>();
    isSledCustomer:boolean | undefined;
}

export class PaymentMethod{
    bpno!: string;
    paymentType! : string;
}

export class InvoiceData{
    bpno!: string;
    cano!: string;
    cno!: string;
    amount!: string;
    currency!: string;
    invoiceNo!: string;
}